import React, { useState } from "react";
import CompanyContext from "./CompanyContext";
const CompanyState = (props) => {
  /**pagination states */
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [record, setRecord] = useState(0);
  const [sortOrder, setSortOrder] = useState("");
  const [sortBy, setSortBy] = useState("createdAt");
  const [filter, setFilter] = useState("");
  const [filterDrop, setFilterDrop] = useState({
    storeFilter: "",
  });

  /**company edit time condition and data object state */
  const [dialog, setDialogs] = useState(false);
  const [isEdit, setIsEdit] = useState(true);
  const [orgId, setOrgId] = useState(null);
  const [formData, setFormData] = useState({
    name: null,
    email: null,
    themeColor: "#000000",
    fontColor: "#000000",
    dialCode1: null,
    mobile1: null,
    dialCode2: null,
    mobile2: null,
    city: null,
    state: null,
    country: null,
    pincode: null,
    tagline: null,
    address: null,
    logo: null,
    roleId: null,
    companyId: null,
    orgId: null,
  });
  const [yes, setYes] = useState(false);
  const [errors, setErrors] = useState({});

  const [crop, setCrop] = useState();
  const [completedCrop, setCompletedCrop] = useState();
  const [scale, setScale] = useState(1);
  const [rotate, setRotate] = useState(0);
  const [aspect, setAspect] = useState();
  const [base64, setBase64] = useState("");
  const [imageModal, setImageModal] = useState(false);
  const [imageType, setImageType] = useState("");
  return (
    <>
      <CompanyContext.Provider
        value={{
          pageSize,
          setPageSize,
          page,
          setPage,
          record,
          setRecord,
          sortOrder,
          setSortOrder,
          sortBy,
          setSortBy,
          filter,
          setFilter,
          filterDrop,
          setFilterDrop,
          dialog,
          setDialogs,
          isEdit,
          setIsEdit,
          orgId,
          setOrgId,
          errors,
          setErrors,
          yes,
          setYes,
          formData,
          setFormData,

          crop,
          setCrop,
          completedCrop,
          setCompletedCrop,
          scale,
          setScale,
          rotate,
          setRotate,
          aspect,
          setAspect,
          base64,
          setBase64,
          imageModal,
          setImageModal,
          imageType,
          setImageType,
        }}
      >
        {props.children}
      </CompanyContext.Provider>
    </>
  );
};

export default CompanyState;
